export default `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 146 146" style="width:19px;margin:0 2px -4px 0;">
  <defs>
    <style>
      .cls-1{fill:#36af5a;stroke:#fff;stroke-width:4px;}
      .cls-2{fill:#fefefe;}
    </style>
  </defs>
  <g transform="translate(-1054 -2344)">
    <g class="cls-1" transform="translate(1054 2344)">
      <circle class="cls-4" cx="73" cy="73" r="73"></circle>
    </g>
    <g transform="translate(1085.521 2378.51)">
      <g transform="translate(0 0)" style="stroke:#dcdcdc;stroke-width:4px;">
        <path class="cls-2" d="M78.8,54.221c-.378-.479,2.144,1.4-33.794-24.148a7.112,7.112,0,0,0-2.169-1.261V25.37a2.358,2.358,0,0,1,1.374-2.27,11.853,11.853,0,1,0-15.6-11.248,2.371,2.371,0,1,0,4.741,0A7.112,7.112,0,1,1,42.708,18.6a7.011,7.011,0,0,0-4.615,6.771v3.493a6.973,6.973,0,0,0-2.169,1.261C0,55.659,2.521,53.767,2.13,54.221a7.087,7.087,0,0,0,4.7,12.143h67.26a7.087,7.087,0,0,0,4.7-12.143Zm-4.855,7.4H6.985a2.333,2.333,0,0,1-1.463-4.086c.277-.252-1.929,1.337,33.227-23.656l.164-.126a2.434,2.434,0,0,1,1.526-.58h0a2.308,2.308,0,0,1,1.526.58l.177.126C77.322,58.887,75.128,57.3,75.392,57.55h0a2.345,2.345,0,0,1-1.45,4.086Z" transform="translate(-0.004 -0.001)"></path>
      </g>
    </g>
  </g>
</svg>`;
